import { featureCollection } from "@turf/turf";
import { Layer, Source } from "react-map-gl/mapbox";
import { createFillAppearance, styleMapper } from "./styles";
import {
  GroupedIncidentFeatures,
  IncidentFeatureCollection,
  IncidentType,
  incidentTypes,
} from "../types";

const isIncidentType = (value: string): value is IncidentType =>
  incidentTypes.includes(value as IncidentType);

export const groupIncidentsByType = (
  collection: IncidentFeatureCollection,
): GroupedIncidentFeatures =>
  collection.features.reduce<GroupedIncidentFeatures>(
    (accumulator, feature) => {
      const incident = feature.properties?.incident;

      if (!incident) return accumulator;
      if (!isIncidentType(incident)) return accumulator;

      if (!accumulator[incident]) accumulator[incident] = [];
      accumulator[incident].push(feature);

      return accumulator;
    },
    {},
  );

export const getIncidentLayers = (collection: IncidentFeatureCollection) => {
  const groupedIncidents = groupIncidentsByType(collection);

  return incidentTypes.map((incidentType) => {
    const features = groupedIncidents[incidentType] ?? [];

    if (features.length === 0) return null;

    const sourceId = `${styleMapper[incidentType].id}-source`;

    return (
      <Source
        key={sourceId}
        id={sourceId}
        type="geojson"
        data={featureCollection(features)}
      >
        <Layer {...createFillAppearance(styleMapper[incidentType])} />
      </Source>
    );
  });
};
